import type { SxProps, Theme } from '@mui/system';

export const radioStyles: SxProps<Theme> = {
    '& .MuiTypography-body1': {
        fontSize: '14px',
    },
    '& .MuiRadio-root': {
        color: 'neutral.lightGray',
    },
    '& .Mui-checked': {
        color: 'primary.main',
    },
};
